import { Title } from "@mui/icons-material"

var english = {
    languageEL: 'English',
    languageEnglish: 'English',
    languageGR: 'Eλληνικά',
    Connection: 'Connection'
    , language_title: 'Language'
    , language: 'English'

    //menu
    , menu_home: 'Home'
    , menu_subcriptions: 'Subscriptions'
    , menu_bills: 'Bills'
    , menu_support: 'Service Request'
    , menu_setting: 'Settings'
    , menu_profile: 'Profile'

    //Landing page
    , check_your_coverage: "Step 1. Enter your address to get started"
    , check_your_coverage_desc: "Enter the address where you'd like Fibre to be installed. Select the correct address from the drop-down options. "
    , check_your_coverage_desc_2: "Click on the 'Check Coverage’ button." 
    , select_your_package: "Step 2. Select Your Package"
    , select_your_package_desc: "After your address has been approved for coverage, choose a package based on availability in your area."
    , select_your_package_desc_2: "Select the package that best fits your needs."
    //Select package
    , subscriptions: "Selected Package"
    , physical_good: "Physical Goods"
    , pro_data_amount: "Amount"
    , your_selection: "Order Summary"
    , your_selection_package_info: "Package"
    , deliver_free: 'Delivery Fee (once-off)'
    , net_amount: 'Nett Amount'
    , discount: 'Discount'
    , total_amount: 'Total Amount'
    , total_amount_due: 'Total Amount Due'
    , confirm_select_device: 'I confirm that I have one of these devices'
    , flylite_packages: 'FlyLite Packages'
    , flysmart_packages: 'FlySmart Packages'
    , flyultra_packages: 'FlyUltra Packages'
    , openserve_packages: 'Openserve Packages'
    , package_availability: 'Package availability is subject to coverage in your area. Ts & Cs apply.'
    , free_fromo: 'Complimentary Promotional Item'
    , free_router: 'Free-to-use Router'
    , free_delivery: 'Free Delivery'
    , store_card_option: 'Upload Card Details for monthly billing'

    // Input Form
    , first_name: "First Name"
    , last_name: "Last Name"
    , your_email: 'Your Email'
    , email_address: 'Email'
    , mobile_number: 'Mobile Number'
    , password: 'Password'
    , confirm_password: 'Confirm Password'
    , id_number: 'ID Number'
    , passport_number: 'Passport Number'
    , upload_id_passport_number: 'Upload ID/Passport (PNG, JPG or PDF <5MB)'
    , upload_proof_address: 'Upload Proof of address (PNG, JPG or PDF <5MB)'
    , same_as_home_address: 'Same as Home/RICA Address'
    , upload_file_desc: "Drag 'n' drop some files here, or click to select files"
    , error_file_upload: 'File is not in the correct format'
    , error_file_size: 'File size exceeded '

    //Button
    , btn_sign_in: 'Sign in'
    , btn_sign_up: "Sign up"
    , btn_send: "Send"
    , btn_save: "Save"
    , btn_done: "Done"
    , btn_cancel: 'Cancel'
    , btn_submit: 'Submit'
    , btn_approve: 'Approve'
    , btn_decline: 'Decline'
    , btn_change_password: 'Change Password'
    , btn_continue: 'Continue'
    , btn_edit: 'Edit'
    , btn_confirm: 'CONFIRM'
    , btn_clear: 'Clear'
    , btn_close: 'Close'
    , btn_ok: 'OK'
    , btn_check_coverage: 'Check Coverage'
    , btn_update: 'Update'
    , btn_add_image: 'Add Image'
    , btn_check_out: "Check Out"
    , btn_create: 'Create'
    , btn_log_out: 'Log out'
    , btn_back: 'Back'
    , btn_detail: 'Detail'
    , btn_more:"More"
    , btn_yes: 'Yes'
    , btn_no: 'No'

    // Login & Register
    , dont_accout_signup: 'Don\'t have an account? Sign up'
    , have_account_signin: 'Did you have an Account? Sign in'
    , sign_up_agree: 'By signing up, I agree to the '
    , term_condition: ' Terms & Conditions '
    , privacy_policy: ' Privacy Notice '
    , and: ' and '
    , forgot_password: "Forgot Password"
    , forgot_password_info: "Enter your email address that you used to register. We'll send you an email with instruction to reset your password."
    , hello: 'Hello'
    , phone_number: 'Phone number'
    , enter_same_password: 'Passwords do not match'
    , back_to_signin: 'Did you have an password? Sign in'
    , registration_desc: 'Kindly complete the form to create your account.'
    , persional_details: 'Personal Details'
    , home_rica_address: 'Installation/RICA Address'
    , delivery_address: 'Delivery Address'
    , choose_payment_method: 'Choose a Payment Method'
    , registration: "Registration"
    , invalid_email_format: 'Invalid email format'
    , phone_number_error: 'Phone number must be 10 digits'
    , phone_number_start_zero: 'Phone number must start with 0'
    , title_refer_friend: 'Have you been referred by a friend?'
    , placeholder_refer_friend: 'Referral code (optional)'
    //Payment
    , payment_credit_card: 'Credit/Debit Cards'
    , payment_voucher: '1ForYou Voucher'
    , payment_mobicred: 'Secure EFT or Mobicred'
    , enter_voucher: 'Enter your 1Voucher Pin'

    //verify page
    , verify_email: 'Verify Your Phone Number'
    , verify_content1: 'An sms with a verification code has been sent to '
    , verify_content2: '. Enter the code to verify your account.'
    , verify_btn: 'VERIFY'
    , verify_resendCode: 'Resend Code'
    , verify_resendCodeMessage1: 'A new verification code has been sent to '
    , verify_resendCodeMessage2: '. Enter the new code to verify your account.'
    , verify_placeholder: 'Verification Code'

    //personal infomation
    , perssonal_infomation: 'Personal Information'
    , gender: 'Gender'
    , male: 'Male'
    , female: 'Female'
    , birthday: 'Date of Birth'
    , save_change: 'Save Changes'
    , enough_18: 'Invalid Birthdate. To participate to loyalty scheme you must be 18 years old and above'
    , select_date: 'Select Date'
    , name_day: 'Name Day'

    //Password
    , old_password: 'Your Old Password'
    , new_password: 'Your New Password'
    , confirm_new_password: 'Confirm New Password'
    , password_desc: 'Please create a secure password including the following criteria:'
    , lowercase_letter: '1 lowercase letter'
    , number: '1Number'
    , dash: '1Dash'
    , changepass_successful: 'The password was updated successfully'

    //My Address
    , address_details: 'Address Details'
    , add_address: 'Add Address'
    , update_address: 'Update address'
    , my_address: 'My Address'
    , edit_address: 'Edit Address'

    //Address
    , address_streetnumber: 'Street Number'
    , address_streetname: 'Street Name'
    , address_towncity: 'Town/City'
    , address_postalcode: 'Postal Code'
    , address_aptnumber: 'Apartment'
    , add_address_success: 'Add Address success!'
    , edit_address_success: 'Edit Address success!'
    , remove_address_success: 'Remove Address success!'
    , address_apartment_name: 'Apartment/Complex/Business Name'
    , address_apartment_number: 'Apartment/Complex/Business Number'
    , state_province_county: 'Province'

    //Notifications
    , notifications: 'Notifications'
    , notifications_detail: 'Notifications Detail'
    , no_detail_number: 'Number:'
    , no_detail_date: 'Date:'
    , no_detail_subject: 'Subject:'
    , no_detail_content: 'Content:'

    //setting
    , contact_information: 'Contact information'
    , contact_information_desc: 'Profile represents your details that are maintained in our records and also allow us to contact you if needed. If there are changes to your details please update them below:'
    , home_rica_address_title: 'Home/RICA Address'
    , home_rica_address_desc_1: 'Payment Setting represent details related to your payments. Provide or update below your main billing address, how you would like to receive your bills and register or update card payment details.'
    , home_rica_address_desc_2: 'Provide your billing address'
    , send_directsale_marketing: 'Send Direct Marketing Material'
    , send_affiliate_marketing: 'Send Affiliate Marketing Material'
    , cards: 'Cards'
    , address_line_1: 'Address line 1'
    , enter_address_line_1: 'Enter Address line 1'
    , marketing_preferences: 'Marketing Preferences'
    , setting_email: 'Enable to stop receiving emails'
    , setting_sms: 'Enable to stop receiving SMS'
    , btn_add_card:"Add Card"

    //Support
    , support_request_title: 'Service Requests'
    , faq: 'FAQ'
    , pending: 'Pending'
    , completed: 'Completed'
    , no_data_found: 'No data found'
    , new_support_request_title: 'New Service Request'
    , select_type: 'Select Type'
    , start_date: 'Start Date'
    , completed_date: 'Actual Completed Date'
    , description: 'Description'
    , support_rq_type: 'Type'
    , service_request_number: 'Service request number'
    , date_title: 'Date'
    , status: 'Status'

    //bills
    , bills: 'Bills'
    , bill_view: 'View'
    , outstanding_amount: 'Outstanding Amount'
    , bill_detail: 'Detail'
    , bill_period: 'Bill Period:'
    , bill_due_date: 'Due Date'
    , bill_credits_debits: 'Debits / Credits'
    , bill_debit: 'Debit'
    , bill_credit: 'Credit'
    , billed: 'Billed'
    , bill_amount: 'Amount'
    , bill_totals: 'Totals'

    //subcriptions
    , subcriptiions_desc: 'Subscriptions represent your service contract with us. Below you can make changes to the services you subscribe to'
    , normal_plan: 'Normal Subscription Plan'
    , sub_name: 'Name:'
    , sub_description: 'Description:'
    , first_active: 'First Activated'
    , sub_Date: 'Date:'
    , billing: 'Billing'
    , frequency: 'Frequency:'
    , sub_state: 'State'
    , btn_upgrade_downgrade : 'Upgrade/Downgrade'
    , btn_terminate : 'Terminate'
    , services: 'Services'
    , btn_proceed: 'Proceed'
    , mess_warning: 'Please choose a service to swap.'
    , please_choose_one: 'Please choose one'
    , please_choose_date: 'Please choose a debit day'

    //Home page
    , remaining_balance: "Remaining balance"
    , anytime_data: "Anytime data"
    , nighttime_data: "Nightime data"
    , subscription_preview:"Subscription Preview"
    , subscription_preview_desc: "Update your subscription services at any time, from any place."
    , support_request: "Service Request"
    , welcome_desc: 'Welcome to your Fly.cool self service portal. For Payment and Top-Up, select Subscriptions in the menu. For help, create a support request below.'
    , btn_continue_payment: 'Continue Payment'
    , btn_reorder: 'Reorder'
    , refer_a_friend: "Refer a Friend"
    , referral_code: 'Referral Code'

    //LCS
    , ACTIVATED: 'Activated'
    , CANCELLED: 'Cancelled'
    , CANCEL_FAILED: 'Cancel failed.'
    , USED: 'Used'

    , pre_order_coverage: 'Heads up! This area isn’t live just yet, but you can still secure your spot with a pre-order.'
    , pre_order_coverage_select_package: 'By clicking Agree below, you’re confirming you’d like to go ahead with a pre-order. Terms & Conditions are available for you to view.'
    , has_coverage: 'Great, your address, has coverage :)'
    , can_select_package: 'You can now proceed by selecting the best service for you.'
    , agree_term: 'By clicking agree below, you are accepting that you wish to proceed. Terms and Conditions are available on '
    , of_service: ' and the link will be sent to you once your order has been accepted.'
    , btn_agree: 'Agree'
    , please_select_address: 'Please select address'
    , available_address: 'Fly.cool is available at your address'
    , available_address_fre_order: 'Fly.cool is available for Pre-Order'
    , btn_agree_continue: 'Agree & Continue'
    , enter_your_address_below: 'Enter your address below'
    , choose_your_package: 'Choose Your Package'
    , cancel_anytime: 'Cancel anytime'
    , per_month: 'per Month'
    , fly_smart_monthly: 'Fly smart Monthly'
    , confirmation: 'Confirmation'
    
    , choose_bill_payment: 'Preferred Payment Date'
    , progress_order: 'Order in progress'
    , order_status: 'Order Status'
    , order_vumatel: 'Order Vumatel'
    , create_contact: 'Create Contact'
    , completed_order: 'Completed'
    , btn_back_to_home: 'Back to Home'
    , address_not_support: 'No coverage found for that address. Please check that the address was entered correctly!'
    , oct10_not_available_in_all_areas: '10/10 not available in all areas'

    //Subcriptions
    , auto_renew: 'Auto renewing'
    , sub_contract_period: 'Contract Period'
    , sub_trial_period: 'Trial period'
    , subscriptions_title: 'Subscriptions'
    , billing_day: 'Billing Day'
    , next_billing_day: 'Next Billing Date'
    , month_title: 'Months'
    , monthly: 'Monthly'
    , state_effective: 'Effective'
    , in_contract: 'In Contract'
    , in_trial: 'In Trial'
    , added_on: 'Added on'
    , removed_on: 'Removed on'
    , firts_activated_on: 'Firts activated on'
    , recurring_charge: 'Recurring charge'
    , recurring_payment: 'Recurring payment'
    , reorder_desc: 'Please try again!'
    , can_not_up_downgrade: 'Service can not up/downgrade'
    , upgrade: 'Upgrade'
    , downgrade: 'Downgrade'
    , change_service_success: 'Change service success'
    , change_service_failed: 'Change service failed'
    , change_service_vumatel_success: 'Change service success'
    , change_service_vumatel_failed: 'Change service failed'
    , must_be_phone_length: 'Phone must contain at least 8 characters'
    , must_be_id_number_length: 'Id number must contain at least 13 characters'
    , must_be_password_length: 'Password must contain at least 8 characters and not include a sequence of numbers'

    , invoicing: 'Invoicing'
    , amount_to_collect: 'Amount to collect'
    , total_discount_amount: 'Total discount amount'
    , total_discount_incl_tax: 'Total discount include TAX'
    , total_net_amount: 'Total Net Amount'
    , total_price: 'Total Price'
    , total_tax_amount: 'Total TAX Amount'
    , wallet_funds_amount: 'Wallet Fund Amount'
    , amount_due: 'Amount due'
    , wait_to_redirect_payment: 'You are being redirected to the payment gateway. Please wait a moment.'
    , terminate_vumatel_failed: 'Terminate service on vumatel failed'
    , terminate_vumatel_success: 'Terminate service on vumatel success'
    , terminate_openserve_failed: 'Terminate service on openserve failed'
    , terminate_openserve_success: 'Terminate service on openserve success'
    , not_found_url_payment: 'The url payment not found. Please back to Home.'
    
    , terminate_crm_success: 'Terminate service on CRM success'
    , terminate_crm_failed: 'Terminate service on CRM failed'

    , change_service: 'Change Service'
    , change_service_progress: 'Change service in progress'
    , change_service_vumatel: 'Change service Vumatel'
    , change_service_openserve: 'Change service Openserve'
    , change_service_crm: 'Change service CRM'
    , change_service_vumetel_failed: 'Change Service vumatel failed'
    , change_service_vumetel_success: 'Change Service vumatel success'
    , change_service_openserve_failed: 'Change Service openserve failed'
    , change_service_openserve_success: 'Change Service openserve success'

    , terminate_vumatel: 'Terminate Vumatel'
    , terminate_crm: 'Terminate CRM'
    , terminate_service: 'Terminate Service'
    , terminate_service_progress: 'Terminate Service in progress'
    , confirm_terminate: 'Do you want termiate this service?'

    //rules password
    , inform_password: 'The password:'
    , inform_password_1: '1) must be at least 8 characters in length.'
    , inform_password_2: '2) can contain alphanumeric characters'
    , inform_password_3: '3) can contain special characters'
    , inform_password_4: '4) cannot contain a sequence of characters or numbers (e.g. "abcdfg" or "123456")'
    , inform_password_5: '5) cannot be set to a previously used password'

    //footer
    , contact_us: 'Contact Us'
    , contact_us_desc: 'Contact us to help you make the right package choice or if you have a specific enquiry.'
    , customer_support: 'Customer Support'
    , email_us_at: 'Email us at'
    , or_follow_us: 'Or follow us on social networks'
    , select_reason: 'Select a reason'
    , reason: 'Reason'
    , please_select_reason: 'Please slect a reason'
    , upload_file_id_number: 'Upload file for id number'
    , upload_file_passport: 'Upload file for passport'
    , file_contact: '(Optional) Upload ID and Proof of Address'
    , error_max_files: 'Up to 5 files can only be uploaded'
    , btn_try: 'Try Again'
    , make_payment: 'Make payment'
    , please_select_device: 'Please make your selection from the complimentary items/devices available.'
    , devices_title: 'Complimentary Promotional Item'

    //invoice page
    , invoice_title: 'Invoices'
    , account_balance: 'Account Balance'
    , overdue_amount: 'Overdue Amount'
    , account_finance: 'Account Finance'
    , invoices: 'Invoices'
    , btn_service_changes: 'Service Changes'
    , upgrade_service: 'Upgrade'
    , period_title: 'Specify period'
    , due_date: 'Due Date'
    , invoice_tax_amount: 'Tax'
    , invoice_net_amount: 'Net'
    , invoice_total_amount: 'Total'
    , unpaid_amount: 'Unpaid Amount'
    , paid_amount: 'Paid Amount'
    , account_title: 'Account'
    , currency_code: 'Currency'
    , invoice: 'Invoice'

    , invoice_number: 'Number'
    , invoice_posted_date: 'Posted Date'
    , invoice_issued_date: 'Issued Date'
    , invoice_due_date: 'Due Date'
    , invoice_overdue_amount: 'Overdue amount'
    , topup_title: 'Top-up'
    , account_management: 'Account Management'
    , my_account_number: 'Account Number'
    , credit_note: 'Credit Note'
    , payment: 'Payment'
    , refund: 'Refund'
    , payout: 'Payout'
    , transfer: 'Transfer'
    , manual_journal: 'Manual Journal'
    , transaction_type: 'Transaction Type'
    , invoice_amount: 'Amount'
    , print_out: 'Print Out'
    , contact_code: 'Contact code'
    , from_date: 'From date'
    , to_date: "To date"
    , btn_pay: 'Pay'
    , enter_amount: 'Enter amount'
    , amount_less_equal_than: 'Amount must be less or equal than '
    , amount_greater_than: 'Amount must be greater than 0!'
    , pay_outstanding_amount: 'Pay for outstanding amount'
    , address_used: 'This location has an in-flight installation order with another ISP. You may not place an order for this address'
    , btn_continue_order: 'Continue Order'
    , btn_change_billing_day: 'Change billing day'
    , current_billing_day: 'Current billing day'
    , new_billing_day: 'Select new billing day'
    , of_the_month: ' of the month'
    , classification: 'Classification'
    , discounted_installation: 'Discounted Installation'
    , activation_fees: 'Activation fees'

    //payment link
    , payment_info_title: 'Your payment info: '
    , payment_info_paid_message: 'Payment paid. You can login in the portal.'
    , btn_cancel_order: 'Cancel Order'
    , create_order_crm: 'Create Order CRM'
    , warning_progress_order: "Your order is being created, please don't close this window!"
    , contact_existing_warning: 'Please check your email to reset your password and then log in again.'
    , agree_term_message: 'Consent for Personal Information Sharing: I hereby consent to FlyCool processing my personal data for the purpose of acquiring my credit report via FlyCool. I also authorize the sharing of this data with registered credit providers and service providers to facilitate the assessment of my eligibility for a Fibre subscription and installation. This may involve conducting credit and fraud checks, as well as consulting and reporting to the South African Fraud Prevention Service.'
    , payment_method: 'Payment Methods'

    , create_your_account: 'Create your Fly.cool account'
    , create_your_account_desc: 'Please make sure your details match your ID document.'
    , refer_a_friend_desc: "Add your Friend's Referral Code below"
    , persional_details_secure: 'This help us activate your service and keep your account secure.'
    , btn_confirm_continue: 'Confirm & Continue'
    , rica_verification: 'RICA Verification'
    , rica_verification_desc: 'RICA is a legal requirement in South Africa. This help us activate your service.'
    , review_and_place_order: "Review and Place Order"
    , order_summary: 'Order Summary'
    , package_title: 'Package'
    , billing_date: 'Billing date'
    , payment_method: 'Payment method'
    , pay_secure_paygate: 'Pay via secure link with '
    , monthly_total: 'Monthly total'
    , order_per_month: 'per month'
    , payments_secure_encrypted: 'Payments are secure and encrypted.'
    , confirmation_sms_email: "You'll receive a confirmation by SMS and email."
    , accept_terms_conditions: 'Accept Terms and Conditions*'
    , place_order: 'Place Order'
    , choose_billing_date: "Choose your monthly Billing Date"
    , billing_date_desc: "This is the day your subscription will be billed each month."
    , monthly_recurring: 'Monthly Recurring'
    , prepaid_non_recurring: 'Prepaid 28 days non-recurring'
    , order_successfully: 'Order created successfully'
    , here_what_happens_next: "Here's what happens next:"
    , reviewing_your_order: "We're reviewing your order"
    , receive_confirmation_via_email: "You'll receive confirmation via email"
    , get_details_soon: "You'll get installation/activation details soon"
    , choose_your_billing_date: "Choose your monthly Billing Date"
    , choose_your_billing_date_desc: "This is the day your subscription will be billed each month."
    , how_would_you_like_to_pay: "How would you like to pay today?"
    , pay_manually_easypay: 'Pay manually using EasyPay at your convenience'
    , pay_using_secure_payment_link: 'Pay now using a secure payment link'
    , save_card_automatic: 'Save the card for automatic monthly Payments?'
    , change_anytime: 'You can change this anytime'
    , pay_at_easypay_kiosk: "Pay at any EasyPay kiosk"
    , btn_continue_order_review: 'Continue to order review'
    
    //date
    , SHORTMONTH: {
        JAN: 'Jan'
        , FEB: 'Feb'
        , MAR: 'Mar'
        , APR: 'Apr'
        , MAY: 'May'
        , JUN: 'Jun'
        , JUL: 'Jul'
        , AUG: 'Aug'
        , SEP: 'Sept'
        , OCT: 'Oct'
        , NOV: 'Nov'
        , DEC: 'Dec'
    }
    , SHORTDAYS: {
        MONDAY: 'Mon',
        TUESDAY: 'Tue',
        WEDNESDAY: 'Wed',
        THURSDAY: 'Thu',
        FRIDAY: 'Fri',
        SATURDAY: 'Sat',
        SUNDAY: 'Sun'
    }
    , LOWERMONTH: {
        JAN: 'Jan'
        , FEB: 'Feb'
        , MAR: 'Mar'
        , APR: 'Apr'
        , MAY: 'May'
        , JUN: 'Jun'
        , JUL: 'Jul'
        , AUG: 'Aug'
        , SEP: 'Sept'
        , OCT: 'Oct'
        , NOV: 'Nov'
        , DEC: 'Dec'
    }
    , ERROR: 'Error'
    , SERVER_ERROR: 'Server Error '
    , VUMATEL_SERVER_ERROR: 'Vumatel Server Error.'
    , OPENSERVE_SERVER_ERROR: 'Openserve Server Error.'
    , SUCCESS: 'Success'
    , EXCEPTION_PROCESS: 'We got a problem while processing your request.'
    , EXCEPTION: 'We got a problem while processing your request. Please try again later.'
    , INVALID_LOGIN: 'Login failed. Phone number or password are not valid'
    , USER_ACCOUNT_NOT_VERIFIED: 'User account is not verified. Use your provided verfication code to continue'
    , INVALID_VERIFICATION_CODE: 'Verification code is not valid'
    , INVALID_VERFICATION_TOKEN: 'Verfication token is not valid'
    , INVALID_TOKEN: 'Token is invalid'
    , INVALID_INPUT: 'Required input should not be empty'
    , CRM_GET_TOKEN_FAIL: 'Required input should not be empty'
    , SCHEMA_VALIDATION_FAILED: ''
    , OBJECT_NOT_FOUND: ' not found'
    , NETWORK_ISSUE: 'Please check your network connection'
    , GET_CONFIG_FAIL: "System not responding. Please try again later."
    , PROFILE_UPDATE_SUSCESS: 'Profile updated successfully.'
    , UPDATE_FAIL: 'Error updating profile. Please try again later.'
    , PHONE_NUMBER_ALREADY_EXIST: 'Account already registered. Please contact support.'
    , CHANGE_PASSWORD_SUCCESS: 'Password updated successfully.'
    , CHANGE_PASSWORD_FAIL: 'Error updating password. Please try again later.'
    , ADD_ADDRESS_SUCCESS: 'Address added successfully.'
    , UPDATE_ADDRESS_SUCCESS: 'Address updated successfully.'
    , REMOVE_ADDRESS_SUCCESS: 'Address deleted successfully.'
    , FAILED_TO_UPDATE_ADDRESS: 'Update address not successful.'
    , FAILED_TO_ADD_ADDRESS: 'Saving new address was not successful.'
    , ADD_ADDRESS_ALREADY_TYPE: 'Saving new Address was not successful. Address with the same type and label already exists.'
    , please_chosse_classification: 'Please chosse classification'
    , create_service_request_success: 'Create service request success'
    , create_service_request_failed: 'Create service request failed'
    , FAILED_TO_REMOVE_ADDRESS: 'Address deletion not successful'
    , EMAIL_NOT_VERIFIED: 'Email address has not been verified. Please resend verification email and follow the instructions to verify your account.'
    , INVALID_EMAIL_LOGIN: 'Sign In failed. Invalid credentials.'
    , ORDER_SUCCESS: 'Order success.'
    , ORDER_FAILED: 'Order failed.'
    , CREATE_ACTIVITY_EXCEPTION: 'Create activity not successful.'
    , ADD_ADDRESS_FAILED: 'Add Address not successful'
    , CREATE_CONTACT_FAILED: 'Create Contact not successful.'
    , CREATE_CONTACT_SUCCESS: 'Create Contact successfully.'
    , CREATE_ORDER_NOT_SUCCESS: 'Oops! Something went wrong with your order. Don’t worry – one of our friendly agents will be in touch soon to help you sort it out. Thanks for your patience!'
    , CREATE_ORDER_SUCCESS: 'Order created successfully.'
    , REGISTRATION_FAIL_CONTACT_EXISTS: 'Account already registered. Please contact support.'
    , CREATE_REORDER_SUCCESS: 'Reorder successfully.'
    , CREATE_REORDER_NOT_SUCCESS: 'Reorder not successful'
    , UPDATE_STATUS_ORDER: 'Your order has been completed successfully'
    , UPDATE_STATUS_ORDER_FAILED: 'Order failed.'
    , PAYMENT_SUCCESS: 'Payment success.'
    , PAYMENT_FAILED: 'Payment failed.'
    , EMAIL_EXISTING: 'The email has been registered. Do you want to Sign in?'
    , INVALIDSUBSCRIPTIONSERVICELIFECYCLESTATEEXCEPTION: 'Invalid subscription service life cycle state. This action can be performed only if the subscription service has specific life cycle states.'
    , INVALID_CONTACTPASSWORD_EXCEPTION: 'Password must be at least 8 (alphanumeric and/or special) characters in length and cannot not contain a sequence of characters or numbers (e.g. “abcd” or “1234”) or used previously.'
    , INVALID_FILE_TYPE: 'Invalid File Type(PNG,DOC,PDF,JSON,JPEG,LOG,SVG,DOCX,EML,XLSX,CSV,XLS,MSG,TXT)'
    , REORDER_EXPIRE_SUCCESS: 'ReOrder successfully.'
    , REORDER_EXPIRE_FAILED: 'ReOrder failed.'
    , FORGOT_PASSWORD_SUCCESS: 'An email with instructions to reset your password has been sent.'
    , FORGOT_PASSWORD_FAIL: 'Error resetting password. Please try again later.'
    , FORGOT_EMAIL_NOT_FOUND_EXCEPTION: 'Unfortunately, we do not recognise this email address.'
    , CAN_NOT_FULFILL_ORDER_EXCEPTION: 'The selected location cannot fulfill your order at this time.'
    , MUST_INPUT_ID_OR_PASSPORT: 'You must input your SA ID or a Passport number if not a SA citizen'
    , UPDATE_CUSTOM_FIELDS_FAILED: 'Update custom fields failed.'
    , SUCCESS_RETRY_PAYMENT: 'Your request has been processed.'
    , ERROR_RETRY_PAYMENT: 'An error occurred, please try again or contact our support on help@fly.cool or send us a whatsapp message on 0110655314.'
    , UPDATE_CARD_MESSAGE: 'You will be redirected to payment gate way. Please wait for a moment'
    , INIT_PAYMENT_SUCCESS: 'Make payment successed.'
    , INIT_PAYMENT_REJECTED: 'Make payment failed.'
    , INIT_PAYMENT_FAILED: 'Init payment failed.'
    , FAILED_TO_REMOVE_CARD: 'Remove card not successful. Please contact support.'
    , REMOVE_CARD_SUCCESS: 'Card removed successfully.'
    , CHANGE_BILLING_DAY_SUCCESS: 'Change billing day successfully.'
    , CHANGE_BILLING_DAY_FAILED: 'Change billing day failed.'
    , CANCEL_ORDER_FAILED: 'Cancel Order failed.'
    , PAYMENT_LINK_NOT_FOUND: 'The provided payment link is invalid. Please double-check carefully as this payment may have already been processed or canceled.'
    , LOCATION_REFERENCE_IS_NOT_AVAILABLE: 'Location reference is not available.'
    , CREATE_CRM_ORDER_EXCEPTION: 'Create Order CRM failed.'
    , CANCEL_ORDER_SUCCESS: 'Order is cancelled.'
    , ORDER_FOR_CONTACT_IS_ALREADY_EXIST: 'Your contact already exists due to an associated order. Please contact support for assistance.'
    , ID_NUMBER_OR_PASSPORT_ALREADY_EXIST: 'Multiple Validation occured. Id number and Passport number must be unique Please close the modal and try again'
    , CREATE_ORDER_FAILED: 'Order creation was unsuccessful.'
    , MESSAGE_CREATE_ORDER_FAILED: 'Oops! Something went wrong with your order. Don’t worry – one of our friendly agents will be in touch soon to help you sort it out. Thanks for your patience!'
    , REGISTER_CONTACT_IS_ALREADY_EXIST: `This email is already in use. Please sign in or choose 'Forgot Password' to reset your login`
    , CONTACT_ALREADY_EXIST: `Contact already exists`
    , PLEASE_VERIFY_OTP: `Please verify otp`
    , VERIFY_OTP: `Verify otp`
    , AUTHENTICATE_AND_SIGN_IN: `Authenticate and sign in`
    , CONTACT_ALREADY_SUBSCRIPTION: `Contact already has an existing subscription. Please advise user to contact call center.`
    , INVALID_LOGIN: `Invalid login.`
    , EMAIL_NOT_VERIFIED: `Email not verified.`
    , TOO_MANY_REQUESTS: `Too many requests.`
    , UNCLASSIFIED_ERROR: `Unclassified error.`
    , INVALID_OTP: `Invalid OTP.`
    , INVALID_ID: `Invalid ID number format. Please try again.`

}
export default {
    english
}